import { border, motion } from "@smartsheet/design-tokens";
import { themed } from "@smartsheet/sds-theme-internal";

export const chipTheme = themed({
    borderRadius: {
        "lodestar-light": "2px",
        "ursa-light": border.radius30,
    },
    height: {
        medium: "28px",
        small: "24px",
        xsmall: "20px",
    },
    padding: {
        left: {
            xsmall: "2px",
            small: "4px",
            medium: "4px",
        },
        right: {
            xsmall: "2px",
            small: "4px",
            medium: "4px",
        },
    },
    showIcon: {
        "lodestar-light": false,
        "ursa-light": true,
    },
    motion: {
        animation: {
            "lodestar-light": "",
            // Note: intentionally breaking away from the default transition timing since the button
            // is so small.
            "ursa-light": `background-color ${motion.animation.default}, opacity 0.1s ${motion.easing.default}`,
        },
    },
    chip: {
        size: {
            "lodestar-light": "medium",
            "ursa-light": "xsmall",
        },
        color: {
            info: {
                color: "azure",
            },
            warning: {
                color: "gold",
            },
            error: {
                color: "red",
            },
            default: {
                color: "neutral",
            },
        },
    },
} as const);

export const avatarChipTheme = themed({
    borderRadius: {
        "lodestar-light": "2px",
        "ursa-light": "100vmax",
    },
    padding: {
        left: {
            xsmall: {
                "lodestar-light": "0.5px",
                "ursa-light": "0px",
            },
            small: {
                "lodestar-light": "4px",
                "ursa-light": "2px",
            },
            medium: {
                "lodestar-light": "4px",
                "ursa-light": "4px",
            },
        },
        right: {
            xsmall: {
                "lodestar-light": "0.5px",
                "ursa-light": "8px",
            },
            small: {
                "lodestar-light": "6px",
                "ursa-light": "8px",
            },
            medium: {
                "lodestar-light": "6px",
                "ursa-light": "8px",
            },
        },
    },
    avatar: {
        padding: {
            left: {
                "lodestar-light": "2px",
                "ursa-light": "0px",
            },
            right: {
                "lodestar-light": "2px",
                "ursa-light": "4px",
            },
        },
    },
} as const);
